
import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { checkExistEmailByCustomerIdRequest, setNewPasswordRequest } from "../apiRequests/authRequests";
import { CheckExistEmailByCustomerIdErrorAction, CheckExistEmailByCustomerIdSuccessAction, SetNewPasswordErrorAction, SetNewPasswordSuccessAction } from "../../actions/authAction";




function* setNewPasswordHandler(action: any) {
    try {

        const response: { data: any } = yield call(setNewPasswordRequest, action.payload)

        yield put(
            SetNewPasswordSuccessAction()
        )

    } catch (error: any) {
        yield put(
            SetNewPasswordErrorAction({
                error: error?.message
            })
        )

    }
}


function* checkExistEmailByCustomerIdHandler(action: any) {
    try {

        const response: { data: any } = yield call(checkExistEmailByCustomerIdRequest, action.payload)

        yield put(
            CheckExistEmailByCustomerIdSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            CheckExistEmailByCustomerIdErrorAction({
                error: error?.message
            })
        )

    }
}

function* authSagaWatcher() {
    yield all([takeLatest(Types.SET_NEW_PASSWORD_REQUEST, setNewPasswordHandler)]);
    yield all([takeLatest(Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_REQUEST, checkExistEmailByCustomerIdHandler)]);

}

export default authSagaWatcher